const getters = {
  menus: state => state.layout.menus,
  token: state => {
    if (state.user.expiresTime <= new Date().getTime()) {
      return ''
    }
    return state.user.token
  },
  user: state => state.user,
  userName: state => state.user.fullName,
  status: state => state.user.status,
  roles: state => state.user.roles,
  setting: state => state.user.setting,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  nasFileHost: state => state.system.nasFileHost,
  classMsg: state => state.message.classMsg,
  sysMsg: state => state.message.sysMsg,
  paypalMsg: state => state.message.paypalMsg,
  selfScheduleRemindMsg: state => state.message.selfScheduleRemindMsg,
  didiMsg: state => state.message.didiMsg,
  errorText: state => state.release.errorText,
  limitCheck: state => state.user.limitCheck,
  feedbackDialog: state => state.layout.feedbackDialog,
  // feedBackMsgDialog:state=>state.layout.feedBackMsgDialog,
  hasPermission: (state, getters) => (requiredRoles) => {
    if (getters.roles.includes('Admin')) return true
    if (Array.isArray(requiredRoles)) {
      return state.user.permissions.some(p => requiredRoles.includes(p))
    }
    if (typeof requiredRoles === 'string') {
      return state.user.permissions.some(p => requiredRoles === p)
    }
    throw new Error('store.getters.hasPermission����ֻ��������ΪArray��String�Ĳ���')
  },
  auditFailure: state=>state.user.auditFailure
}
export default getters
